import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ThermoDevice:String,
  },
  mutations: {
    SetThermo (state, value){
      state.ThermoDevice = value
    }

  },
  actions: {
    

  }
})
